Object.assign(window.NomaCareProductFinder.prototype, {
  createProductCard(match, index) {
    const { product } = match;
    const article = document.createElement('article');
    article.className = 'nc-product-finder__product-card';

    const media = document.createElement('div');
    media.className = 'nc-product-finder__product-media';

    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.imageAlt;
      image.loading = 'lazy';
      image.width = 720;
      image.height = 720;
      media.append(image);
    }

    const position = document.createElement('span');
    position.className = 'nc-product-finder__product-position';
    const compareAllBundles =
      this.answers.category === 'bundles' && this.answers.coverage === 'compare-bundles';
    position.textContent = compareAllBundles
      ? 'Published multi-target product'
      : index === 0
        ? 'Best coverage match'
        : 'Alternative match';
    media.append(position);

    const content = document.createElement('div');
    content.className = 'nc-product-finder__product-content';

    const meta = document.createElement('div');
    meta.className = 'nc-product-finder__product-meta';

    const format = document.createElement('span');
    format.className = 'nc-product-finder__product-format';
    format.textContent = productFormatLabel(product);

    const availability = document.createElement('span');
    availability.className = 'nc-product-finder__availability';
    availability.dataset.available = String(product.available);
    availability.textContent = product.available ? 'Available' : 'Currently unavailable';
    meta.append(format, availability);

    const title = document.createElement('h3');
    title.className = 'nc-product-finder__product-title';
    title.textContent = product.title;

    const summary = document.createElement('p');
    summary.className = 'nc-product-finder__product-summary';
    summary.textContent = product.summary;

    const reason = document.createElement('p');
    reason.className = 'nc-product-finder__match-reason';
    const reasonLead = document.createElement('strong');
    reasonLead.textContent = 'Why it appears: ';
    reason.append(reasonLead, document.createTextNode(this.matchReason(match)));

    const chips = document.createElement('div');
    chips.className = 'nc-product-finder__target-list';
    product.targets.forEach((target) => {
      const chip = document.createElement('span');
      chip.className = 'nc-product-finder__target-chip';
      chip.textContent = NOMA_CARE_FINDER.targetLabels[target] || target;
      chips.append(chip);
    });

    content.append(meta, title, summary, reason, chips);

    if (this.showPrices && hasValidPrice(product)) {
      const price = document.createElement('p');
      price.className = 'nc-product-finder__product-price';
      price.textContent = formatMoney(product.priceCents, product.currency);
      content.append(price);
    }

    const actions = document.createElement('div');
    actions.className = 'nc-product-finder__product-actions';

    const link = document.createElement('a');
    link.className = 'nc-product-finder__product-link';
    link.href = product.url;
    link.textContent = 'View product';
    link.setAttribute('aria-label', `View ${product.title}`);

    const compare = document.createElement('div');
    compare.className = 'nc-product-finder__compare';

    const compareInput = document.createElement('input');
    compareInput.className = 'nc-product-finder__compare-input';
    compareInput.type = 'checkbox';
    compareInput.id = `Compare-${this.dataset.sectionId || 'finder'}-${product.handle}`;
    compareInput.value = product.handle;
    compareInput.setAttribute('aria-label', `Compare ${product.title}`);
    if (this.compareGuidance?.id) {
      compareInput.setAttribute('aria-describedby', this.compareGuidance.id);
    }
    compareInput.addEventListener('change', () => this.toggleComparison(product.handle, compareInput));

    const compareLabel = document.createElement('label');
    compareLabel.className = 'nc-product-finder__compare-label';
    compareLabel.htmlFor = compareInput.id;
    compareLabel.textContent = 'Compare';

    compare.append(compareInput, compareLabel);
    actions.append(link);
    if (this.currentMatches.length > 1) actions.append(compare);
    content.append(actions);
    article.append(media, content);

    return article;
  },

  createCollectionCard([titleText, url, copyText]) {
    const article = document.createElement('article');
    article.className = 'nc-product-finder__product-card';

    const content = document.createElement('div');
    content.className = 'nc-product-finder__product-content';

    const badge = document.createElement('span');
    badge.className = 'nc-product-finder__product-format';
    badge.textContent = 'Catalogue category';

    const title = document.createElement('h3');
    title.className = 'nc-product-finder__product-title';
    title.textContent = titleText;

    const copy = document.createElement('p');
    copy.className = 'nc-product-finder__product-summary';
    copy.textContent = copyText;

    const actions = document.createElement('div');
    actions.className = 'nc-product-finder__product-actions';

    const link = document.createElement('a');
    link.className = 'nc-product-finder__product-link';
    link.href = url;
    link.textContent = 'Browse collection';
    link.setAttribute('aria-label', `Browse ${titleText}`);

    actions.append(link);
    content.append(badge, title, copy, actions);
    article.append(content);

    return article;
  },

  createEmptyState() {
    const empty = document.createElement('div');
    empty.className = 'nc-product-finder__empty';

    const title = document.createElement('strong');
    title.textContent = 'No direct catalogue match was found.';

    const copy = document.createElement('p');
    copy.textContent =
      'Change one of your answers or browse the full catalogue. The Product Finder does not infer a medical alternative when coverage does not match.';

    const link = document.createElement('a');
    link.className = 'nc-product-finder__button nc-product-finder__button--secondary';
    link.href = '/collections/all';
    link.textContent = 'Browse all products';

    empty.append(title, copy, link);
    return empty;
  },

  toggleComparison(handle, input) {
    if (input.checked && this.selectedForComparison.size >= 3) {
      input.checked = false;
      return;
    }

    if (input.checked) {
      this.selectedForComparison.add(handle);
    } else {
      this.selectedForComparison.delete(handle);
    }

    this.updateCompareState();

    if (!this.comparison.hidden && this.selectedForComparison.size >= 2) {
      this.renderComparison({ focus: false, scroll: false });
    }
  },

  updateCompareState() {
    const count = this.selectedForComparison.size;
    const atLimit = count >= 3;
    this.compareCount.textContent = atLimit
      ? '3 products selected. Maximum reached.'
      : `${count} product${count === 1 ? '' : 's'} selected`;
    this.openComparisonButton.disabled = count < 2;

    if (this.compareGuidance) {
      this.compareGuidance.textContent = atLimit
        ? 'Maximum of three selected. Remove one product before choosing another.'
        : 'Select two or three products to compare their stated product details.';
    }
    this.resultGrid.querySelectorAll('.nc-product-finder__compare-input').forEach((input) => {
      input.disabled = atLimit && !input.checked;
      const label = input.nextElementSibling;
      if (label) {
        label.title = input.disabled ? 'You can compare up to three products.' : '';
      }
    });

    if (count < 2) this.closeComparison();
  },

  renderComparison(options = {}) {
    const { focus = true, scroll = true } = options;
    const products = [...this.selectedForComparison]
      .map((handle) => this.catalogue.find((product) => product.handle === handle))
      .filter(Boolean);

    if (products.length < 2) return;

    this.comparisonHead.replaceChildren();
    this.comparisonBody.replaceChildren();

    const headerRow = document.createElement('tr');
    const attributeHeader = document.createElement('th');
    attributeHeader.scope = 'col';
    attributeHeader.textContent = 'Attribute';
    headerRow.append(attributeHeader);

    products.forEach((product) => {
      const heading = document.createElement('th');
      heading.scope = 'col';
      const link = document.createElement('a');
      link.href = product.url;
      link.textContent = product.title;
      heading.append(link);
      headerRow.append(heading);
    });

    this.comparisonHead.append(headerRow);

    const rows = [
      ['Format', (product) => productFormatLabel(product)],
      [
        'Screening targets',
        (product) =>
          joinNatural(product.targets.map((target) => NOMA_CARE_FINDER.targetLabels[target] || target)),
      ],
      ['Number of stated targets', (product) => String(product.targetCount)],
      ['Pack format', (product) => product.packFormat],
    ];

    if (this.showPrices && products.some((product) => hasValidPrice(product))) {
      rows.push([
        'Price',
        (product) =>
          hasValidPrice(product) ? formatMoney(product.priceCents, product.currency) : 'See product page',
      ]);
    }

    rows.push([
      'Availability',
      (product) => (product.available ? 'Available' : 'Currently unavailable'),
    ]);

    rows.forEach(([label, valueFor]) => {
      const row = document.createElement('tr');
      const heading = document.createElement('th');
      heading.scope = 'row';
      heading.textContent = label;
      row.append(heading);

      products.forEach((product) => {
        const cell = document.createElement('td');
        cell.textContent = valueFor(product);
        row.append(cell);
      });

      this.comparisonBody.append(row);
    });

    this.comparison.hidden = false;

    if (scroll) {
      this.comparison.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start',
      });
    }

    if (focus) {
      this.comparisonHeading?.focus({ preventScroll: true });
    }
  },

  closeComparison(options = {}) {
    const { scroll = false, restoreFocus = false } = options;
    this.comparison.hidden = true;

    if (scroll) {
      this.compareBar.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
      });
    }

    if (restoreFocus) {
      this.openComparisonButton?.focus({ preventScroll: true });
    }
  },

  restart() {
    this.answers = {};
    this.route = ['category', 'targets', 'format', 'context'];
    this.stepIndex = 0;
    this.selectedForComparison.clear();
    this.currentMatches = [];
    this.resultGrid.replaceChildren();
    this.results.hidden = true;
    this.journey.hidden = false;
    this.careNotice.hidden = true;
    this.compareBar.hidden = true;
    this.closeComparison();
    this.renderQuestion();

    this.journey.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }
});
